import React from 'react';
import JumboThemeSidebarContext from "./JumboThemeSidebarContext";
import {createTheme} from "@mui/material/styles";
import PropTypes from 'prop-types';

const JumboThemeSidebar = ({children, init}) => {
    const [sidebarTheme, setSidebarTheme] = React.useState(init);

    const themeSidebarContextValue = React.useMemo(() => ({
        sidebarTheme: createTheme(sidebarTheme),
        setSidebarTheme: setSidebarTheme,
    }), [sidebarTheme, setSidebarTheme]);

    return (
        <JumboThemeSidebarContext.Provider value={themeSidebarContextValue}>
            {children}
        </JumboThemeSidebarContext.Provider>
    );
};

JumboThemeSidebar.propTypes = {
    children: PropTypes.node,
    init: PropTypes.string,
}

export default JumboThemeSidebar;